
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"19","viewBox":"0 0 14.175 19.2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_36400","data-name":"Group 36400","transform":"translate(-451.206 -374.4)","fill":"#5a677d"}},[_c('path',{attrs:{"id":"Path_27677","data-name":"Path 27677","d":"M452.754 378.715l.107.007a.773.773 0 00.76-.656 2.48 2.48 0 014.906 0 .771.771 0 00.758.657.768.768 0 00.773-.77c0-.014-.006-.1-.008-.111a4 4 0 00-3.972-3.441 4.055 4.055 0 00-3.981 3.442.774.774 0 00.658.873z"}}),_c('path',{attrs:{"id":"Path_27678","data-name":"Path 27678","d":"M465.042 382.2l-.009-.011a2.116 2.116 0 00-2.346-.563 2.655 2.655 0 00-.086-.116 2.116 2.116 0 00-2.347-.562l-.016-.024a2.123 2.123 0 00-2.153-.739v-.985a1.948 1.948 0 00-2.258-1.576 1.963 1.963 0 00-1.58 1.629v6.513a7.837 7.837 0 00-1.3-.462.276.276 0 00-.075-.01 1.367 1.367 0 00-.958.453l-.15.131a1.654 1.654 0 00-.138 2.336 1.01 1.01 0 00.119.119l3.441 3.667a7.215 7.215 0 004.526 1.6c3.126.026 5.666-2.08 5.669-4.7v-5.761a1.505 1.505 0 00-.339-.939zm-1.069 6.7c0 1.887-1.867 3.424-4.165 3.426a5.937 5.937 0 01-3.643-1.242l-3.445-3.666a.271.271 0 01-.1-.2c0-.046.008-.449.2-.454a6.3 6.3 0 011.241.371l.6.312a1.027 1.027 0 00.271.057.677.677 0 00.73-.638l-.005-7.557a.529.529 0 011.026-.054l.005 5.631a.711.711 0 00.826.575.724.724 0 00.58-.628l-.005-2.994a.529.529 0 011.026-.054l.005 3.1a.711.711 0 00.826.575.724.724 0 00.58-.628v-2.318a.518.518 0 01.607-.422.531.531 0 01.418.369v2.424a.713.713 0 00.829.576.729.729 0 00.579-.629v-1.642a.516.516 0 01.215-.337.511.511 0 01.39-.087.526.526 0 01.421.372z"}})])])
          )
        }
      }
    